import {AbstractControl, ValidationErrors, Validator, ValidatorFn} from '@angular/forms';

export function matchFieldsValidator(firstFieldName: string, secondFieldName: string): ValidatorFn {
  return (c: AbstractControl): ValidationErrors | null => {
    const firstField = c.get(firstFieldName);
    const secondField = c.get(secondFieldName);

    if (firstField.pristine || secondField.pristine) {
      return null;
    }

    if (firstField.value === secondField.value) {
      return null;
    }

    return {
      'matchFields': true
    };
  };
}
